import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyAO53I4m17YAnOkoAVv-Z5NDbJRWjT92qM",
  authDomain: "spinningcat-416bc.firebaseapp.com",
  projectId: "spinningcat-416bc",
  storageBucket: "spinningcat-416bc.firebasestorage.app",
  messagingSenderId: "571642755417",
  appId: "1:571642755417:web:ee1fd52273d29f36be7448",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
